<template>
	<Loading :loading="loading" text="报表数据计算中..."/>
	<vxe-toolbar class-name="px-8px">
		<template #buttons>
			<DatePicker ref="dateComp" v-if="dimension==='QUARTER'" :option = "quarterRange" v-model="voucherDate" type="quarter" :clearable="false"/>
			<account-date-choose v-else v-model="voucherDate"/>
			<!-- jxd负债表平衡提示 -->
			<Space :width="10"/>
			<Tag v-if="msgBalance" color="#f50">{{msgBalance}}</Tag>
			<Tag v-if="msgBalance">请检查本月是否结转损益，是否有新增一级科目及报表公式是否正确！</Tag>
			<!-- jxd负债表平衡提示 -->
			<Select v-if="report.templateKey == 'xjll'" v-model="xjllFZHS" :datas="paramXjll" :deletable="false" @change="loadData()"></Select>
		</template>
		<template #tools>
			<Checkbox v-if="report.templateKey == 'xjll'" @change="afterReportShow" v-model="afterRep" style="padding-right: 10px">显示调整后报表</Checkbox>
			<vxe-button @click="loadData()" icon="fa fa-refresh" content="刷新"/>
			<vxe-button v-if="report.templateKey == 'xjll' && dimension !='QUARTER'" @click="xjlEvent('begin')" icon="fa fa-minus-circle" content="现金流期初调整"/>
			<vxe-button v-if="report.templateKey == 'xjll' && dimension !='QUARTER'" @click="xjlEvent('mounth')" icon="fa fa-minus-square" content="现金流月份调整"/>
			<vxe-button @click="printData" icon="fa fa-print" content="打印"/>
			<vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
		</template>
	</vxe-toolbar>
	<div ref="reportContent" class="flex-1 p-8px" style="overflow-y: auto">
		<!-- jxd height="auto" 表头自动固定 -->
		<vxe-table ref="xTable" :data="dataList" border height="auto">
			<vxe-column :title="h.title" v-for="h in headers" :field="h.key" :align="h.isTitle?(h.width?'center':'left'):'right'" :width="h.isTitle?h.width||'auto':150">
				<template #default="{row}">
					<div v-if="row.id" class="col-title">
						<template v-if="h.isTitle && !h.isRowNum">
							<span :style="{'padding-left': (15*row.level)+'px'}">{{ row.title }}</span>
							<span @click.stop="editFormula(row.id)" v-if="row.editFormulas" class="col-title-edit text-hover text-12px ml-8px primary-color">
								<i class="fa fa-edit"></i> 编辑公式
							</span>
						</template>
						<template v-else-if="h.isRowNum">
							{{ row.rowNum }}
						</template>
					</div>
					<div v-else :class="row[h.key+ 'isBolder']?'font-bold text-14px':''" class="col-title">
						<template v-if="h.isTitle">
							<span :style="{'padding-left': (15*row[h.key+ 'lv'])+'px'}">{{ row[h.key] }}</span>
							<span @click.stop="editFormula(row[h.key+ 'id'])" v-if="row[h.key+ 'editFormulas']" class="col-title-edit text-hover text-12px ml-8px primary-color">
								<i class="fa fa-edit"></i> 编辑公式
							</span>
						</template>
						<span v-else>{{ row[h.key] }}</span>
					</div>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
	<div>
		<vxe-modal @close="xjlBeginning = false" v-model="xjlBeginning" :title="xjlTitle" width="800" height="60%" resize remember>
			<template #default>
				<div style="margin-bottom: 8px;display: flex;justify-content: right;">
					<vxe-button @click="submitAdjustment" icon="fa fa-paste" content="保存"/>
					<vxe-button @click="xjlBeginning = false" icon="fa fa-repeat" content="返回"/>
				</div>
				<vxe-table :data="xjlData">
					<vxe-column title="项目" width="400">
						<template #default="{row}">
							<div>{{ row.项目 }}</div>
						</template>
					</vxe-column>
					<vxe-column title="行次" width="140">
						<template #default="{row}">
							<div>{{ row.项目rowNum }}</div>
						</template>
					</vxe-column>
					<!-- :disabled="row.项目isBolder" 判断是否可以填写内容 -->
					<vxe-column v-if="yearOrMonth  == 'year'" title="本年累计期初" width="220">
						<template #default="{row}">
							<!-- <vxe-input v-model="row.项目本年累计金额"></vxe-input> -->
							<vxe-input :disabled="row.项目isBolder" v-model="row.项目本年累计金额" @blur="calcCash(row,'year')"></vxe-input>
						</template>
					</vxe-column>
					<vxe-column v-if="yearOrMonth  == 'month'" title="本期金额" width="220">
						<template #default="{row}">
							<!-- <vxe-input v-model="row.项目本期金额"></vxe-input> -->
							<vxe-input :disabled="row.项目isBolder" v-model="row.项目本期金额" @blur="calcCash(row,'month')"></vxe-input>
						</template>
					</vxe-column>
				</vxe-table>
			</template>
		</vxe-modal>
	</div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "ZcfzbReportView",
}
</script>

<script setup>
import ReportApi from "@/api/report";
import CashFlowDiy from "@/api/CashFlowDiy";
import setting from "@/api/setting";
import accountbook from "@/api/accountbook";
import {ref, toRefs, watch, h, computed,nextTick} from "vue";
import {useStore} from "vuex";
import manba from "manba";
import {repeat, toArrayTree, toStringJSON} from "xe-utils";
import AccountDateChoose from "@/components/AccountDateChoose";
import {VXETable} from "vxe-table";
import {layer} from "@layui/layer-vue";
import TemplateItemFormulaModal from "@/views/report/template/TemplateItemFormulaModal.vue";
import EventBus from "@js/common/EventBus";
import print from "@js/common/print";
import {dictMapping} from "heyui.ext";
import ExcelJS from "exceljs";
import {downloadBlob} from "download.js";
import {message} from "heyui.ext";



const afterRep = ref(false)

const paramXjll = ref([{ title: '普通公式法', key: 0 },{ title: '辅助核算法', key: 1 }])
const xjllFZHS = ref(paramXjll.value[0].key)
const xjlBeginning = ref()//现金流调整jxd弹出窗
const xjlData = ref([])//现金流调整jxd弹出窗数据
const xjlTitle = ref("")//现金流调整jxd弹出窗标题
const yearOrMonth = ref("")//现金流调整是年度还是月度
const store = useStore();
const User = store.state.User;
const {currentAccountSets} = store.state

const props = defineProps(['report', 'dimension']);

const {report, dimension} = toRefs(props);
const reportContent = ref(null);
const xTable = ref(null);
//const headers = ref({});
const dataList = ref([]);
const reportItems = ref([]);
const loading = ref(false);
const dateComp = ref(null);
const voucherDate = ref(currentAccountSets.currentAccountDate)
const msgBalance = ref("");//负债表平衡检测消息提示存储jxd
const yearCashFlow = ref({});
const monthCashFlow = ref({});
const quarterRange = ref({});

if (dimension.value === 'QUARTER') {
	quarterRange.value = {"start":manba(User.checkoutList[User.checkoutList.length - 1].checkDate).startOf(manba.QUARTER).format(),"end":manba(User.checkoutList[0].checkDate).endOf(manba.QUARTER).format()}
	voucherDate.value = manba(currentAccountSets.currentAccountDate).startOf(manba.QUARTER).format()
}

const showDate = computed(() => {
	if (dimension.value === 'QUARTER') {
		return dateComp.value.showDate;
	}
	return manba(voucherDate.value).format('YYYY年MM月');
})

//计算调整项目金额，例如编辑了一项，自动计算其他
const calcCash = (row,type) => {
	console.log(row,User.accountSets.accountStandard)
	console.log(xjlData.value)
	if(User.accountSets.accountStandard == "SMALL_BUSINESS"){
		if(row.项目 == '加：期初现金余额'){
			//直接调用计算，并跳出
			calcCashEnd(type);
			return;
		}
		xjlData.value.forEach(item => {
			switch (item.项目){
				case "经营活动产生的现金流量净额":
					let a = xjlData.value.find(items => items.项目 == "销售产成品、商品、提供劳务收到的现金");
					let b = xjlData.value.find(items => items.项目 == "收到其他与经营活动有关的现金");
					let c = xjlData.value.find(items => items.项目 == "购买原材料、商品、接受劳务支付的现金");
					let d = xjlData.value.find(items => items.项目 == "支付的职工薪酬");
					let e = xjlData.value.find(items => items.项目 == "支付的税费");
					let f = xjlData.value.find(items => items.项目 == "支付其他与经营活动有关的现金");
					if(type == 'year'){
						let num = Number(a.项目本年累计金额) + Number(b.项目本年累计金额) - Number(c.项目本年累计金额) - Number(d.项目本年累计金额) - Number(e.项目本年累计金额) - Number(f.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(a.项目本期金额) + Number(b.项目本期金额) - Number(c.项目本期金额) - Number(d.项目本期金额) - Number(e.项目本期金额) - Number(f.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "投资活动产生的现金流量净额":
					let a1 = xjlData.value.find(items => items.项目 == "收回短期投资、长期债券投资和长期股权投资收到的现金");
					let b1 = xjlData.value.find(items => items.项目 == "取得投资收益收到的现金");
					let c1 = xjlData.value.find(items => items.项目 == "处置固定资产、无形资产和其他非流动资产收回的现金净额");
					let d1 = xjlData.value.find(items => items.项目 == "短期投资、长期债券投资和长期股权投资支付的现金");
					let e1 = xjlData.value.find(items => items.项目 == "购建固定资产、无形资产和其他非流动资产支付的现金");
					if(type == 'year'){
						let num = Number(a1.项目本年累计金额) + Number(b1.项目本年累计金额) + Number(c1.项目本年累计金额) - Number(d1.项目本年累计金额) - Number(e1.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(a1.项目本期金额) + Number(b1.项目本期金额) + Number(c1.项目本期金额) - Number(d1.项目本期金额) - Number(e1.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "筹资活动产生的现金流量净额":
					let a2 = xjlData.value.find(items => items.项目 == "取得借款收到的现金");
					let b2 = xjlData.value.find(items => items.项目 == "吸收投资者投资收到的现金");
					let c2 = xjlData.value.find(items => items.项目 == "偿还借款本金支付的现金");
					let d2 = xjlData.value.find(items => items.项目 == "偿还借款利息支付的现金");
					let e2 = xjlData.value.find(items => items.项目 == "分配利润支付的现金");
					if(type == 'year'){
						let num = Number(a2.项目本年累计金额) + Number(b2.项目本年累计金额) - Number(c2.项目本年累计金额) - Number(d2.项目本年累计金额) - Number(e2.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(a2.项目本期金额) + Number(b2.项目本期金额) - Number(c2.项目本期金额) - Number(d2.项目本期金额) - Number(e2.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
			}
		})
		calcCashEnd(type);
	}else if(User.accountSets.accountStandard == "BUSINESS" || User.accountSets.accountStandard == "BUSINESS_NEW_2019"){
		/**
		 * 企业的因为有小计，所以如果顺序净额在小计前，那计算应该会有问题
		 * 但是顺序应该不会出现问题，故现在先不拆
		 * 如果现实中有顺序不一致的，把净额都单独拿出来，在一个独立的循环中计算即可
		 */
		 if(row.项目 == '加：期初现金及现金等价物余额'){
			//直接调用计算，并跳出
			calcCashEndB(type);
			return;
		}
		xjlData.value.forEach(item => {
			switch (item.项目){
				case "经营活动现金流入小计":
					let a = xjlData.value.find(items => items.项目 == "销售商品、提供劳务收到的现金");
					let b = xjlData.value.find(items => items.项目 == "收到的税费返还");
					let c = xjlData.value.find(items => items.项目 == "收到其他与经营活动有关的现金");
					if(type == 'year'){
						let num = Number(a.项目本年累计金额) + Number(b.项目本年累计金额) + Number(c.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(a.项目本期金额) + Number(b.项目本期金额) + Number(c.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "经营活动现金流出小计":
					let a1 = xjlData.value.find(items => items.项目 == "购买商品、接受劳务支付的现金");
					let b1 = xjlData.value.find(items => items.项目 == "支付给职工以及为职工支付的现金");
					let c1 = xjlData.value.find(items => items.项目 == "支付的各项税费");
					let d1 = xjlData.value.find(items => items.项目 == "支付其他与经营活动有关的现金");
					if(type == 'year'){
						let num = Number(a1.项目本年累计金额) + Number(b1.项目本年累计金额) + Number(c1.项目本年累计金额) + Number(d1.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(a1.项目本期金额) + Number(b1.项目本期金额) + Number(c1.项目本期金额) + Number(d1.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "经营活动产生的现金流量净额":
					let dj = xjlData.value.find(items => items.项目 == "经营活动现金流入小计");
					let ej = xjlData.value.find(items => items.项目 == "经营活动现金流出小计");
					if(type == 'year'){
						let num = Number(dj.项目本年累计金额) - Number(ej.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(dj.项目本期金额) - Number(ej.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;

				case "投资活动现金流入小计":
					let at = xjlData.value.find(items => items.项目 == "收回投资收到的现金");
					let bt = xjlData.value.find(items => items.项目 == "取得投资收益收到的现金");
					let ct = xjlData.value.find(items => items.项目 == "处置固定资产、无形资产和其他长期资产收回的现金净额");
					let et = xjlData.value.find(items => items.项目 == "处置子公司及其他营业单位收到的现金净额");
					let ft = xjlData.value.find(items => items.项目 == "收到其他与投资活动有关的现金");
					if(type == 'year'){
						let num = Number(at.项目本年累计金额) + Number(bt.项目本年累计金额) + Number(ct.项目本年累计金额) + Number(et.项目本年累计金额) + Number(ft.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(at.项目本期金额) + Number(bt.项目本期金额) + Number(ct.项目本期金额) + Number(et.项目本期金额) + Number(ft.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "投资活动现金流出小计":
					let at1 = xjlData.value.find(items => items.项目 == "购建固定资产、无形资产和其他长期资产所支付的现金");
					let bt1 = xjlData.value.find(items => items.项目 == "投资支付的现金");
					let ct1 = xjlData.value.find(items => items.项目 == "取得子公司及其他营业单位支付的现金净额");
					let dt1 = xjlData.value.find(items => items.项目 == "支付其他与投资活动有关的现金");
					if(type == 'year'){
						let num = Number(at1.项目本年累计金额) + Number(bt1.项目本年累计金额) + Number(ct1.项目本年累计金额) + Number(dt1.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(at1.项目本期金额) + Number(bt1.项目本期金额) + Number(ct1.项目本期金额) + Number(dt1.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "投资活动产生的现金流量净额":
					let djt = xjlData.value.find(items => items.项目 == "投资活动现金流入小计");
					let ejt = xjlData.value.find(items => items.项目 == "投资活动现金流出小计");
					if(type == 'year'){
						let num = Number(djt.项目本年累计金额) - Number(ejt.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(djt.项目本期金额) - Number(ejt.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;

				case "筹资活动现金流入小计":
					let atx = xjlData.value.find(items => items.项目 == "吸收投资收到的现金");
					let btx = xjlData.value.find(items => items.项目 == "取得借款收到的现金");
					let ctx = xjlData.value.find(items => items.项目 == "收到其他与筹资活动有关的现金");
					if(type == 'year'){
						let num = Number(atx.项目本年累计金额) + Number(btx.项目本年累计金额) + Number(ctx.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(atx.项目本期金额) + Number(btx.项目本期金额) + Number(ctx.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "筹资活动现金流出小计":
					let at1x = xjlData.value.find(items => items.项目 == "偿还债务支付的现金");
					let bt1x = xjlData.value.find(items => items.项目 == "分配股利、利润或偿付利息支付的现金");
					let ct1x = xjlData.value.find(items => items.项目 == "支付其他与筹资活动有关的现金");
					if(type == 'year'){
						let num = Number(at1x.项目本年累计金额) + Number(bt1x.项目本年累计金额) + Number(ct1x.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(at1x.项目本期金额) + Number(bt1x.项目本期金额) + Number(ct1x.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
				case "筹资活动产生的现金流量净额":
					let djtx = xjlData.value.find(items => items.项目 == "筹资活动现金流入小计");
					let ejtx = xjlData.value.find(items => items.项目 == "筹资活动现金流出小计");
					if(type == 'year'){
						let num = Number(djtx.项目本年累计金额) - Number(ejtx.项目本年累计金额);
						item.项目本年累计金额 = num.toFixed(2);
					}else{
						let num = Number(djtx.项目本期金额) - Number(ejtx.项目本期金额);
						item.项目本期金额 = num.toFixed(2);
					}
				break;
			}
		})
		calcCashEndB(type);
	}
}
//计算调整项目金额，这里计算最终的期末数/企业准则
const calcCashEndB = (type) => {
	let a = xjlData.value.find(items => items.项目 == "经营活动产生的现金流量净额");
	let b = xjlData.value.find(items => items.项目 == "投资活动产生的现金流量净额");
	let c = xjlData.value.find(items => items.项目 == "筹资活动产生的现金流量净额");
	let c1 = xjlData.value.find(items => items.项目 == "四、汇率变动对现金及现金等价物的影响");
	xjlData.value.forEach(item => {
		if(item.项目 == '五、现金及现金等价物净增加额'){
			if(type == 'year'){
				item.项目本年累计金额 = Number(a.项目本年累计金额) + Number(b.项目本年累计金额) + Number(c.项目本年累计金额) + Number(c1.项目本年累计金额);
			}else{
				item.项目本期金额 = Number(a.项目本期金额) + Number(b.项目本期金额) + Number(c.项目本期金额) + Number(c1.项目本期金额);
			}
		}
	})
	let d = xjlData.value.find(items => items.项目 == "五、现金及现金等价物净增加额");
	let e = xjlData.value.find(items => items.项目 == "加：期初现金及现金等价物余额");
	xjlData.value.forEach(item => {
		if(item.项目 == '六、期末现金余额'){
			if(type == 'year'){
				item.项目本年累计金额 = Number(d.项目本年累计金额) + Number(e.项目本年累计金额);
			}else{
				item.项目本期金额 = Number(d.项目本期金额) + Number(e.项目本期金额);
			}
		}
	})
}
//计算调整项目金额，这里计算最终的期末数/小企业
const calcCashEnd = (type) => {
	let a = xjlData.value.find(items => items.项目 == "经营活动产生的现金流量净额");
	let b = xjlData.value.find(items => items.项目 == "投资活动产生的现金流量净额");
	let c = xjlData.value.find(items => items.项目 == "筹资活动产生的现金流量净额");
	xjlData.value.forEach(item => {
		if(item.项目 == '四、现金净增加额'){
			if(type == 'year'){
				item.项目本年累计金额 = Number(a.项目本年累计金额) + Number(b.项目本年累计金额) + Number(c.项目本年累计金额);
			}else{
				item.项目本期金额 = Number(a.项目本期金额) + Number(b.项目本期金额) + Number(c.项目本期金额);
			}
		}
	})
	let d = xjlData.value.find(items => items.项目 == "四、现金净增加额");
	let e = xjlData.value.find(items => items.项目 == "加：期初现金余额");
	xjlData.value.forEach(item => {
		if(item.项目 == '五、期末现金余额'){
			if(type == 'year'){
				item.项目本年累计金额 = Number(d.项目本年累计金额) + Number(e.项目本年累计金额);
			}else{
				item.项目本期金额 = Number(d.项目本期金额) + Number(e.项目本期金额);
			}
		}
	})
}

//显示调整后的现金流报表
const afterReportShow = (val) => {
	if(val){
		if(yearCashFlow.value.id){
			dataList.value.forEach(item => {				
				item.项目本年累计金额  = Number(item.项目本年累计金额.replace(/,/g, '')) +  Number(yearCashFlow.value.cashFlowDetails.find(items => items.项目id === item.项目id).项目本年累计金额)
				if(item.项目本年累计金额 == 0){
					item.项目本年累计金额 = ''
				}else{
					item.项目本年累计金额 = item.项目本年累计金额.toFixed(2)
				}
			})
		}
		if(monthCashFlow.value.id){
			dataList.value.forEach(item => {
				item.项目本期金额 =  Number(item.项目本期金额.replace(/,/g, '')) +  Number(monthCashFlow.value.cashFlowDetails.find(items => items.项目id === item.项目id).项目本期金额)
				if(item.项目本期金额 == 0){
					item.项目本期金额 = ''
				}else{
					item.项目本期金额 = item.项目本期金额.toFixed(2)
				}
			})
		}
	}else{
		loadData();
	}
}

//jxd现金流调整保存
const submitAdjustment = ()=>{
	//根据调整的是本年还是本期，进行数据整理提交
	if(yearOrMonth.value == 'year') {
		//本年累计期初调整
		xjlData.value.forEach(item => {
			delete item.项目本期金额;
		})
		let data = {
			"id":yearCashFlow.value.id,
			"isYearMonth": 1,
			"year": manba(voucherDate.value).format('YYYY'),
			"cashFlowDetails":xjlData.value,
		}
		CashFlowDiy.saveTpl(data).then((res)=>{
			message.success('保存成功')
			yearCashFlow.value = res.data || {"id":null}
		})
	}else{
		//本期金额调整
		xjlData.value.forEach(item => {
			delete item.项目本年累计金额;
		})
		let data = {
			"id":monthCashFlow.value.id,
			"isYearMonth": 0,
			"year": manba(voucherDate.value).format('YYYY'),
			"month": manba(voucherDate.value).format('MM'),
			"cashFlowDetails":xjlData.value,
		}
		CashFlowDiy.saveTpl(data).then((res)=>{
			message.success('保存成功')
			monthCashFlow.value = res.data || {"id":null}
		})
	}
}

//查询年度调整现金流
const yCashFlow = () =>{
	CashFlowDiy.findTpl({"isYearMonth": 1,"year": manba(voucherDate.value).format('YYYY'),"month": manba(voucherDate.value).format('MM')}).then((res)=>{
		yearCashFlow.value = res.data || {"id":null}
	})
}

//查询月度调整现金流
const mCashFlow = (type = "NOTQUARTER") =>{
	if(type == "NOTQUARTER"){
		CashFlowDiy.findTpl({"isYearMonth": 0,"year": manba(voucherDate.value).format('YYYY'),"month": manba(voucherDate.value).format('MM')}).then((res)=>{
			monthCashFlow.value = res.data || {"id":null}
		})
	}else{
		let m1,m2,m3;
		CashFlowDiy.findTpl({"isYearMonth": 0,"year": manba(voucherDate.value).format('YYYY'),"month": manba(voucherDate.value).format('MM')}).then((res)=>{
			m1 = res.data || {"id":null}
			CashFlowDiy.findTpl({"isYearMonth": 0,"year": manba(voucherDate.value).format('YYYY'),"month": Number(manba(voucherDate.value).format('MM'))+1}).then((res)=>{
				m2 = res.data || {"id":null}
				CashFlowDiy.findTpl({"isYearMonth": 0,"year": manba(voucherDate.value).format('YYYY'),"month": Number(manba(voucherDate.value).format('MM'))+2}).then((res)=>{
					m3 = res.data || {"id":null}
					let arr = [m1,m2,m3];
					// 过滤并合并非空的结果  
  					let nonEmptyResults = arr.filter(result => result.id !== null);  
					if(nonEmptyResults.length == 0){
						monthCashFlow.value = {"id":null}
					}else if(nonEmptyResults.length == 1){
						monthCashFlow.value = nonEmptyResults[0]
					}else if(nonEmptyResults.length > 1){
						let obj = nonEmptyResults[0];
						for(let i = 1;i<nonEmptyResults.length;i++){
							obj.cashFlowDetails.forEach(item =>{
								item.项目本期金额 = Number(item.项目本期金额) + Number(nonEmptyResults[i].cashFlowDetails.find(items => items.项目id === item.项目id).项目本期金额)
							})
						}
						monthCashFlow.value = obj
					}
				})
			})
		})
	}
}
//jxd现金流调整弹出窗口事件
const xjlEvent	= (type) => {
	/**
	 * 目前通过dataList读取出现金流报表的所有项目
	 * 1.在现金流报表打开的时候，就已经根据月份年度，查询了期初本期的调整项目，以及月份的调整项目
	 * 2.如果上面查询没有数据，则直接使用报表的项目，然后值都是0，如果有则直接使用接口返回的数据，设置这个弹出内容
	 * 3.之后如果保存则提交到后台
	 * 4.数据合并，如果账套是启用年，期初合并到本年累计，，，这个也在打开现金流的时候设置
	 * 5.如果年度月份一致，本期合并到本期，，，这个也在打开现金流的时候设置
	 * 6.当现金流是季度报表的时候，查询月份就是1-3 4-6 7-9 10-12
	 */
	let data = JSON.parse(JSON.stringify(dataList.value))
	// 使用filter方法去除null值
	let cleanedArray = data.filter(item => item !== null);
	cleanedArray.forEach(item => {
		item.项目本年累计金额 = '';
		item.项目本期金额 = '';
	})
	if(type === 'begin') {
		//期初调整项目
		let array = yearCashFlow.value.id ? yearCashFlow.value.cashFlowDetails : cleanedArray
		xjlData.value = array.filter(item => item !== null);
		xjlTitle.value = "现金流期初调整项目"
		yearOrMonth.value = "year"
		xjlBeginning.value = true
	}else if(type === 'mounth'){
		//月度调整项目
		let array = monthCashFlow.value.id ? monthCashFlow.value.cashFlowDetails : cleanedArray
		xjlData.value = array.filter(item => item !== null);
		xjlTitle.value = "现金流月份调整项目"
		yearOrMonth.value = "month"
		xjlBeginning.value = true
	}
}

const headers = computed(() => {
	let tree = toArrayTree(props.report.items);
	let _headers = [];
	if (tree.filter(f => f.isClassified).length > 0) {
		tree.forEach(root => {
			_headers.push({title: root.title, key: root.title, isTitle: true})
			_headers.push({title: '行次', key: root.title + 'rowNum', isTitle: true, isRowNum: true, width: 50})
			report.value.reportCols.forEach(col => {
				_headers.push({title: col.title, key: root.title + col.title})
			})
		})
	} else {
		_headers.push({title: '项目', key: '项目', isTitle: true})
		_headers.push({title: '行次', key: '项目rowNum', isTitle: true, isRowNum: true, width: 50})
		report.value.reportCols.forEach(col => {
			_headers.push({title: col.title, key: "项目" + col.title})
		})
	}
	return _headers;
})

const xjlCal = (period,year,original,accountSetType) => {
	original.forEach(item => {
		if(item.title != "加：期初现金余额" && accountSetType == "SMALL_BUSINESS"){
			item.values.本期金额 = 0;
			item.values.本年累计金额 = 0;
		}else if(item.title != "加：期初现金及现金等价物余额" && (accountSetType == "BUSINESS" || User.accountSets.accountStandard == "BUSINESS_NEW_2019")){
			item.values.本期金额 = 0;
			item.values.本年累计金额 = 0;
		}
	})
	if(accountSetType == "SMALL_BUSINESS"){
		//小企业准则
		let oneNetAmount = {"本年累计金额":0,"本期金额":0};
		let twoNetAmount = {"本年累计金额":0,"本期金额":0};
		let thirdNetAmount = {"本年累计金额":0,"本期金额":0};
		original.forEach(items => {
			switch (items.title){
				case "销售产成品、商品、提供劳务收到的现金":
					let p1 = period.find(item => item.name === "销售产成品、商品、提供劳务收到的现金");
					let y1 = year.find(item => item.name === "销售产成品、商品、提供劳务收到的现金");
					if(y1){items.values.本年累计金额 = (Number(y1.currentDebitAmount) + (-Number(y1.currentCreditAmount))).toFixed(2)}
					if(p1){items.values.本期金额 = (Number(p1.currentDebitAmount) + (-Number(p1.currentCreditAmount))).toFixed(2)}
					if(p1)oneNetAmount.本期金额 = (Number(items.values.本期金额) + Number(oneNetAmount.本期金额)).toFixed(2);
					if(y1){oneNetAmount.本年累计金额 = (Number(items.values.本年累计金额) + Number(oneNetAmount.本年累计金额)).toFixed(2)};
				break;	
				case "收到其他与经营活动有关的现金":
					let p2 = period.find(item => item.name === "收到其他与经营活动有关的现金");
					let y2 = year.find(item => item.name === "收到其他与经营活动有关的现金");
					if(y2)items.values.本年累计金额 = (Number(y2.currentDebitAmount) + (-Number(y2.currentCreditAmount))).toFixed(2)
					if(p2)items.values.本期金额 = (Number(p2.currentDebitAmount) + (-Number(p2.currentCreditAmount))).toFixed(2)
					if(p2)oneNetAmount.本期金额 = (Number(items.values.本期金额) + Number(oneNetAmount.本期金额)).toFixed(2);
					if(y2)oneNetAmount.本年累计金额 = (Number(items.values.本年累计金额) + Number(oneNetAmount.本年累计金额)).toFixed(2);
				break;	
				case "购买原材料、商品、接受劳务支付的现金":
					let p3 = period.find(item => item.name === "购买原材料、商品、接受劳务支付的现金");
					let y3 = year.find(item => item.name === "购买原材料、商品、接受劳务支付的现金");
					if(y3)items.values.本年累计金额 = -(Number(y3.currentDebitAmount) + (-Number(y3.currentCreditAmount))).toFixed(2)
					if(p3)items.values.本期金额 = -(Number(p3.currentDebitAmount) + (-Number(p3.currentCreditAmount))).toFixed(2)
					if(p3)oneNetAmount.本期金额 = (Number(oneNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y3)oneNetAmount.本年累计金额 = (Number(oneNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;	
				case "支付的职工薪酬":
					let p4 = period.find(item => item.name === "支付的职工薪酬");
					let y4 = year.find(item => item.name === "支付的职工薪酬");
					if(y4)items.values.本年累计金额 = -(Number(y4.currentDebitAmount) + (-Number(y4.currentCreditAmount))).toFixed(2)
					if(p4)items.values.本期金额 = -(Number(p4.currentDebitAmount) + (-Number(p4.currentCreditAmount))).toFixed(2)
					if(p4)oneNetAmount.本期金额 = (Number(oneNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y4)oneNetAmount.本年累计金额 = (Number(oneNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;	
				case "支付的税费":
					let p5 = period.find(item => item.name === "支付的税费");
					let y5 = year.find(item => item.name === "支付的税费");
					if(y5)items.values.本年累计金额 = -(Number(y5.currentDebitAmount) + (-Number(y5.currentCreditAmount))).toFixed(2)
					if(p5)items.values.本期金额 = -(Number(p5.currentDebitAmount) + (-Number(p5.currentCreditAmount))).toFixed(2)
					if(p5)oneNetAmount.本期金额 = (Number(oneNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y5)oneNetAmount.本年累计金额 = (Number(oneNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;	
				case "支付其他与经营活动有关的现金":
					let p6 = period.find(item => item.name === "支付其他与经营活动有关的现金");
					let y6 = year.find(item => item.name === "支付其他与经营活动有关的现金");
					if(y6)items.values.本年累计金额 = -(Number(y6.currentDebitAmount) + (-Number(y6.currentCreditAmount))).toFixed(2)
					if(p6)items.values.本期金额 = -(Number(p6.currentDebitAmount) + (-Number(p6.currentCreditAmount))).toFixed(2)
					if(p6)oneNetAmount.本期金额 = (Number(oneNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y6)oneNetAmount.本年累计金额 = (Number(oneNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;	
				
				case "收回短期投资、长期债券投资和长期股权投资收到的现金":
					let p7 = period.find(item => item.name === "收回短期投资、长期债券投资和长期股权投资收到的现金");
					let y7 = year.find(item => item.name === "收回短期投资、长期债券投资和长期股权投资收到的现金");
					if(y7)items.values.本年累计金额 = (Number(y7.currentDebitAmount) + (-Number(y7.currentCreditAmount))).toFixed(2)
					if(p7)items.values.本期金额 = (Number(p7.currentDebitAmount) + (-Number(p7.currentCreditAmount))).toFixed(2)
					if(p7)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y7)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;	
				case "取得投资收益收到的现金":
					let p8 = period.find(item => item.name === "取得投资收益收到的现金");
					let y8 = year.find(item => item.name === "取得投资收益收到的现金");
					if(y8)items.values.本年累计金额 = (Number(y8.currentDebitAmount) + (-Number(y8.currentCreditAmount))).toFixed(2)
					if(p8)items.values.本期金额 = (Number(p8.currentDebitAmount) + (-Number(p8.currentCreditAmount))).toFixed(2)
					if(p8)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y8)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "处置固定资产、无形资产和其他非流动资产收回的现金净额":
					let p9 = period.find(item => item.name === "处置固定资产、无形资产和其他非流动资产收回的现金净额");
					let y9 = year.find(item => item.name === "处置固定资产、无形资产和其他非流动资产收回的现金净额");
					if(y9)items.values.本年累计金额 = (Number(y9.currentDebitAmount) + (-Number(y9.currentCreditAmount))).toFixed(2)
					if(p9)items.values.本期金额 = (Number(p9.currentDebitAmount) + (-Number(p9.currentCreditAmount))).toFixed(2)
					if(p9)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y9)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "短期投资、长期债券投资和长期股权投资支付的现金":
					let p10 = period.find(item => item.name === "短期投资、长期债券投资和长期股权投资支付的现金");
					let y10 = year.find(item => item.name === "短期投资、长期债券投资和长期股权投资支付的现金");
					if(y10)items.values.本年累计金额 = -(Number(y10.currentDebitAmount) + (-Number(y10.currentCreditAmount))).toFixed(2)
					if(p10)items.values.本期金额 = -(Number(p10.currentDebitAmount) + (-Number(p10.currentCreditAmount))).toFixed(2)
					if(p10)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y10)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "购建固定资产、无形资产和其他非流动资产支付的现金":
					let p11 = period.find(item => item.name === "购建固定资产、无形资产和其他非流动资产支付的现金");
					let y11 = year.find(item => item.name === "购建固定资产、无形资产和其他非流动资产支付的现金");
					if(y11)items.values.本年累计金额 = -(Number(y11.currentDebitAmount) + (-Number(y11.currentCreditAmount))).toFixed(2)
					if(p11)items.values.本期金额 = -(Number(p11.currentDebitAmount) + (-Number(p11.currentCreditAmount))).toFixed(2)
					if(p11)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y11)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;

				case "取得借款收到的现金":
					let p12 = period.find(item => item.name === "取得借款收到的现金");
					let y12 = year.find(item => item.name === "取得借款收到的现金");
					if(y12)items.values.本年累计金额 = (Number(y12.currentDebitAmount) + (-Number(y12.currentCreditAmount))).toFixed(2)
					if(p12)items.values.本期金额 = (Number(p12.currentDebitAmount) + (-Number(p12.currentCreditAmount))).toFixed(2)
					if(p12)thirdNetAmount.本期金额 = (Number(thirdNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y12)thirdNetAmount.本年累计金额 = (Number(thirdNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "吸收投资者投资收到的现金":
					let p13 = period.find(item => item.name === "吸收投资者投资收到的现金");
					let y13 = year.find(item => item.name === "吸收投资者投资收到的现金");
					if(y13)items.values.本年累计金额 = (Number(y13.currentDebitAmount) + (-Number(y13.currentCreditAmount))).toFixed(2)
					if(p13)items.values.本期金额 = (Number(p13.currentDebitAmount) + (-Number(p13.currentCreditAmount))).toFixed(2)
					if(p13)thirdNetAmount.本期金额 = (Number(thirdNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y13)thirdNetAmount.本年累计金额 = (Number(thirdNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "偿还借款本金支付的现金":
					let p14 = period.find(item => item.name === "偿还借款本金支付的现金");
					let y14 = year.find(item => item.name === "偿还借款本金支付的现金");
					if(y14)items.values.本年累计金额 = -(Number(y14.currentDebitAmount) + (-Number(y14.currentCreditAmount))).toFixed(2)
					if(p14)items.values.本期金额 = -(Number(p14.currentDebitAmount) + (-Number(p14.currentCreditAmount))).toFixed(2)
					if(p14)thirdNetAmount.本期金额 = (Number(thirdNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y14)thirdNetAmount.本年累计金额 = (Number(thirdNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "偿还借款利息支付的现金":
					let p15 = period.find(item => item.name === "偿还借款利息支付的现金");
					let y15 = year.find(item => item.name === "偿还借款利息支付的现金");
					if(y15)items.values.本年累计金额 = -(Number(y15.currentDebitAmount) + (-Number(y15.currentCreditAmount))).toFixed(2)
					if(p15)items.values.本期金额 = -(Number(p15.currentDebitAmount) + (-Number(p15.currentCreditAmount))).toFixed(2)
					if(p15)thirdNetAmount.本期金额 = (Number(thirdNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y15)thirdNetAmount.本年累计金额 = (Number(thirdNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "分配利润支付的现金":
					let p16 = period.find(item => item.name === "分配利润支付的现金");
					let y16 = year.find(item => item.name === "分配利润支付的现金");
					if(y16)items.values.本年累计金额 = -(Number(y16.currentDebitAmount) + (-Number(y16.currentCreditAmount))).toFixed(2)
					if(p16)items.values.本期金额 = -(Number(p16.currentDebitAmount) + (-Number(p16.currentCreditAmount))).toFixed(2)
					if(p16)thirdNetAmount.本期金额 = (Number(thirdNetAmount.本期金额) - Number(items.values.本期金额)).toFixed(2);
					if(y16)thirdNetAmount.本年累计金额 = (Number(thirdNetAmount.本年累计金额) - Number(items.values.本年累计金额)).toFixed(2);
				break;
			}
		})
		let o = original.find(item => item.title === "经营活动产生的现金流量净额");
		o.values.本期金额 = oneNetAmount.本期金额;
		o.values.本年累计金额 = oneNetAmount.本年累计金额;

		let t = original.find(item => item.title === "投资活动产生的现金流量净额");
		t.values.本期金额 = twoNetAmount.本期金额;
		t.values.本年累计金额 = twoNetAmount.本年累计金额;
		
		let t3 = original.find(item => item.title === "筹资活动产生的现金流量净额");
		t3.values.本期金额 = thirdNetAmount.本期金额;
		t3.values.本年累计金额 = thirdNetAmount.本年累计金额;


		let f = original.find(item => item.title === "四、现金净增加额");
		f.values.本期金额 = Number(o.values.本期金额)  + Number(t.values.本期金额) + Number(t3.values.本期金额);
		f.values.本年累计金额 = Number(o.values.本年累计金额) + Number(t.values.本年累计金额) + Number(t3.values.本年累计金额);;

		let qc = original.find(item => item.title === "加：期初现金余额");
		let qm = original.find(item => item.title === "五、期末现金余额");
		qm.values.本期金额 = Number(f.values.本期金额) + Number(qc.values.本期金额);
		qm.values.本年累计金额 = Number(f.values.本年累计金额) + Number(qc.values.本年累计金额);
		return original;
	}else if(accountSetType == "BUSINESS" || User.accountSets.accountStandard == "BUSINESS_NEW_2019"){
		let oneNetAmount = {"本年累计金额":0,"本期金额":0};//经营活动现金流入小计
		let twoNetAmount = {"本年累计金额":0,"本期金额":0};//经营活动现金流出小计
		let netAmount1 = {"本年累计金额":0,"本期金额":0};//投资活动现金流入小计
		let netAmount2 = {"本年累计金额":0,"本期金额":0};//投资活动现金流出小计
		let netAmount3 = {"本年累计金额":0,"本期金额":0};//筹资活动现金流入小计
		let netAmount4 = {"本年累计金额":0,"本期金额":0};//筹资活动现金流出小计
		//企业准则
		original.forEach(items => {
			switch (items.title){
				case "销售商品、提供劳务收到的现金":
					let p1 = period.find(item => item.name === "销售商品、提供劳务收到的现金");
					let y1 = year.find(item => item.name === "销售商品、提供劳务收到的现金");
					if(y1){items.values.本年累计金额 = (Number(y1.currentDebitAmount) + (-Number(y1.currentCreditAmount))).toFixed(2)}
					if(p1){items.values.本期金额 = (Number(p1.currentDebitAmount) + (-Number(p1.currentCreditAmount))).toFixed(2)}
					if(p1)oneNetAmount.本期金额 = (Number(items.values.本期金额) + Number(oneNetAmount.本期金额)).toFixed(2);
					if(y1){oneNetAmount.本年累计金额 = (Number(items.values.本年累计金额) + Number(oneNetAmount.本年累计金额)).toFixed(2)};
				break;	
				case "收到的税费返还":
					let p2 = period.find(item => item.name === "收到的税费返还");
					let y2 = year.find(item => item.name === "收到的税费返还");
					if(y2){items.values.本年累计金额 = (Number(y2.currentDebitAmount) + (-Number(y2.currentCreditAmount))).toFixed(2)}
					if(p2){items.values.本期金额 = (Number(p2.currentDebitAmount) + (-Number(p2.currentCreditAmount))).toFixed(2)}
					if(p2)oneNetAmount.本期金额 = (Number(items.values.本期金额) + Number(oneNetAmount.本期金额)).toFixed(2);
					if(y2){oneNetAmount.本年累计金额 = (Number(items.values.本年累计金额) + Number(oneNetAmount.本年累计金额)).toFixed(2)};
				break;	
				case "收到其他与经营活动有关的现金":
					let p3 = period.find(item => item.name === "收到其他与经营活动有关的现金");
					let y3 = year.find(item => item.name === "收到其他与经营活动有关的现金");
					if(y3){items.values.本年累计金额 = (Number(y3.currentDebitAmount) + (-Number(y3.currentCreditAmount))).toFixed(2)}
					if(p3){items.values.本期金额 = (Number(p3.currentDebitAmount) + (-Number(p3.currentCreditAmount))).toFixed(2)}
					if(p3)oneNetAmount.本期金额 = (Number(items.values.本期金额) + Number(oneNetAmount.本期金额)).toFixed(2);
					if(y3){oneNetAmount.本年累计金额 = (Number(items.values.本年累计金额) + Number(oneNetAmount.本年累计金额)).toFixed(2)};
				break;	
				case "购买商品、接受劳务支付的现金":
					let p5 = period.find(item => item.name === "购买商品、接受劳务支付的现金");
					let y5 = year.find(item => item.name === "购买商品、接受劳务支付的现金");
					if(y5)items.values.本年累计金额 = -(Number(y5.currentDebitAmount) + (-Number(y5.currentCreditAmount))).toFixed(2)
					if(p5)items.values.本期金额 = -(Number(p5.currentDebitAmount) + (-Number(p5.currentCreditAmount))).toFixed(2)
					if(p5)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y5)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "支付给职工以及为职工支付的现金":
					let p6 = period.find(item => item.name === "支付给职工以及为职工支付的现金");
					let y6 = year.find(item => item.name === "支付给职工以及为职工支付的现金");
					if(y6)items.values.本年累计金额 = -(Number(y6.currentDebitAmount) + (-Number(y6.currentCreditAmount))).toFixed(2)
					if(p6)items.values.本期金额 = -(Number(p6.currentDebitAmount) + (-Number(p6.currentCreditAmount))).toFixed(2)
					if(p6)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y6)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "支付的各项税费":
					let p7 = period.find(item => item.name === "支付的各项税费");
					let y7 = year.find(item => item.name === "支付的各项税费");
					if(y7)items.values.本年累计金额 = -(Number(y7.currentDebitAmount) + (-Number(y7.currentCreditAmount))).toFixed(2)
					if(p7)items.values.本期金额 = -(Number(p7.currentDebitAmount) + (-Number(p7.currentCreditAmount))).toFixed(2)
					if(p7)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y7)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "支付其他与经营活动有关的现金":
					let p8 = period.find(item => item.name === "支付其他与经营活动有关的现金");
					let y8 = year.find(item => item.name === "支付其他与经营活动有关的现金");
					if(y8)items.values.本年累计金额 = -(Number(y8.currentDebitAmount) + (-Number(y8.currentCreditAmount))).toFixed(2)
					if(p8)items.values.本期金额 = -(Number(p8.currentDebitAmount) + (-Number(p8.currentCreditAmount))).toFixed(2)
					if(p8)twoNetAmount.本期金额 = (Number(twoNetAmount.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y8)twoNetAmount.本年累计金额 = (Number(twoNetAmount.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;

				case "收回投资收到的现金":
					let p9 = period.find(item => item.name === "收回投资收到的现金");
					let y9 = year.find(item => item.name === "收回投资收到的现金");
					if(y9){items.values.本年累计金额 = (Number(y9.currentDebitAmount) + (-Number(y9.currentCreditAmount))).toFixed(2)}
					if(p9){items.values.本期金额 = (Number(p9.currentDebitAmount) + (-Number(p9.currentCreditAmount))).toFixed(2)}
					if(p9)netAmount1.本期金额 = (Number(items.values.本期金额) + Number(netAmount1.本期金额)).toFixed(2);
					if(y9){netAmount1.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount1.本年累计金额)).toFixed(2)};
				break;	
				case "取得投资收益收到的现金":
					let p10 = period.find(item => item.name === "取得投资收益收到的现金");
					let y10 = year.find(item => item.name === "取得投资收益收到的现金");
					if(y10){items.values.本年累计金额 = (Number(y10.currentDebitAmount) + (-Number(y10.currentCreditAmount))).toFixed(2)}
					if(p10){items.values.本期金额 = (Number(p10.currentDebitAmount) + (-Number(p10.currentCreditAmount))).toFixed(2)}
					if(p10)netAmount1.本期金额 = (Number(items.values.本期金额) + Number(netAmount1.本期金额)).toFixed(2);
					if(y10){netAmount1.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount1.本年累计金额)).toFixed(2)};
				break;	
				case "处置固定资产、无形资产和其他长期资产收回的现金净额":
					let p11 = period.find(item => item.name === "处置固定资产、无形资产和其他长期资产收回的现金净额");
					let y11 = year.find(item => item.name === "处置固定资产、无形资产和其他长期资产收回的现金净额");
					if(y11){items.values.本年累计金额 = (Number(y11.currentDebitAmount) + (-Number(y11.currentCreditAmount))).toFixed(2)}
					if(p11){items.values.本期金额 = (Number(p11.currentDebitAmount) + (-Number(p11.currentCreditAmount))).toFixed(2)}
					if(p11)netAmount1.本期金额 = (Number(items.values.本期金额) + Number(netAmount1.本期金额)).toFixed(2);
					if(y11){netAmount1.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount1.本年累计金额)).toFixed(2)};
				break;	
				case "处置子公司及其他营业单位收到的现金净额":
					let p12 = period.find(item => item.name === "处置子公司及其他营业单位收到的现金净额");
					let y12 = year.find(item => item.name === "处置子公司及其他营业单位收到的现金净额");
					if(y12){items.values.本年累计金额 = (Number(y12.currentDebitAmount) + (-Number(y12.currentCreditAmount))).toFixed(2)}
					if(p12){items.values.本期金额 = (Number(p12.currentDebitAmount) + (-Number(p12.currentCreditAmount))).toFixed(2)}
					if(p12)netAmount1.本期金额 = (Number(items.values.本期金额) + Number(netAmount1.本期金额)).toFixed(2);
					if(y12){netAmount1.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount1.本年累计金额)).toFixed(2)};
				break;	
				case "收到其他与投资活动有关的现金":
					let p13 = period.find(item => item.name === "收到其他与投资活动有关的现金");
					let y13 = year.find(item => item.name === "收到其他与投资活动有关的现金");
					if(y13){items.values.本年累计金额 = (Number(y13.currentDebitAmount) + (-Number(y13.currentCreditAmount))).toFixed(2)}
					if(p13){items.values.本期金额 = (Number(p13.currentDebitAmount) + (-Number(p13.currentCreditAmount))).toFixed(2)}
					if(p13)netAmount1.本期金额 = (Number(items.values.本期金额) + Number(netAmount1.本期金额)).toFixed(2);
					if(y13){netAmount1.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount1.本年累计金额)).toFixed(2)};
				break;	
				case "购建固定资产、无形资产和其他长期资产所支付的现金":
					let p14 = period.find(item => item.name === "购建固定资产、无形资产和其他长期资产所支付的现金");
					let y14 = year.find(item => item.name === "购建固定资产、无形资产和其他长期资产所支付的现金");
					if(y14)items.values.本年累计金额 = -(Number(y14.currentDebitAmount) + (-Number(y14.currentCreditAmount))).toFixed(2)
					if(p14)items.values.本期金额 = -(Number(p14.currentDebitAmount) + (-Number(p14.currentCreditAmount))).toFixed(2)
					if(p14)netAmount2.本期金额 = (Number(netAmount2.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y14)netAmount2.本年累计金额 = (Number(netAmount2.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "投资支付的现金":
					let p15 = period.find(item => item.name === "投资支付的现金");
					let y15 = year.find(item => item.name === "投资支付的现金");
					if(y15)items.values.本年累计金额 = -(Number(y15.currentDebitAmount) + (-Number(y15.currentCreditAmount))).toFixed(2)
					if(p15)items.values.本期金额 = -(Number(p15.currentDebitAmount) + (-Number(p15.currentCreditAmount))).toFixed(2)
					if(p15)netAmount2.本期金额 = (Number(netAmount2.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y15)netAmount2.本年累计金额 = (Number(netAmount2.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "取得子公司及其他营业单位支付的现金净额":
					let p16 = period.find(item => item.name === "取得子公司及其他营业单位支付的现金净额");
					let y16 = year.find(item => item.name === "取得子公司及其他营业单位支付的现金净额");
					if(y16)items.values.本年累计金额 = -(Number(y16.currentDebitAmount) + (-Number(y16.currentCreditAmount))).toFixed(2)
					if(p16)items.values.本期金额 = -(Number(p16.currentDebitAmount) + (-Number(p16.currentCreditAmount))).toFixed(2)
					if(p16)netAmount2.本期金额 = (Number(netAmount2.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y16)netAmount2.本年累计金额 = (Number(netAmount2.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "支付其他与投资活动有关的现金":
					let p17 = period.find(item => item.name === "支付其他与投资活动有关的现金");
					let y17 = year.find(item => item.name === "支付其他与投资活动有关的现金");
					if(y17)items.values.本年累计金额 = -(Number(y17.currentDebitAmount) + (-Number(y17.currentCreditAmount))).toFixed(2)
					if(p17)items.values.本期金额 = -(Number(p17.currentDebitAmount) + (-Number(p17.currentCreditAmount))).toFixed(2)
					if(p17)netAmount2.本期金额 = (Number(netAmount2.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y17)netAmount2.本年累计金额 = (Number(netAmount2.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;

				case "吸收投资收到的现金":
					let p18 = period.find(item => item.name === "吸收投资收到的现金");
					let y18 = year.find(item => item.name === "吸收投资收到的现金");
					if(y18){items.values.本年累计金额 = (Number(y18.currentDebitAmount) + (-Number(y18.currentCreditAmount))).toFixed(2)}
					if(p18){items.values.本期金额 = (Number(p18.currentDebitAmount) + (-Number(p18.currentCreditAmount))).toFixed(2)}
					if(p18)netAmount3.本期金额 = (Number(items.values.本期金额) + Number(netAmount3.本期金额)).toFixed(2);
					if(y18){netAmount3.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount3.本年累计金额)).toFixed(2)};
				break;	
				case "取得借款收到的现金":
					let p19 = period.find(item => item.name === "取得借款收到的现金");
					let y19 = year.find(item => item.name === "取得借款收到的现金");
					if(y19){items.values.本年累计金额 = (Number(y19.currentDebitAmount) + (-Number(y19.currentCreditAmount))).toFixed(2)}
					if(p19){items.values.本期金额 = (Number(p19.currentDebitAmount) + (-Number(p19.currentCreditAmount))).toFixed(2)}
					if(p19)netAmount3.本期金额 = (Number(items.values.本期金额) + Number(netAmount3.本期金额)).toFixed(2);
					if(y19){netAmount3.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount3.本年累计金额)).toFixed(2)};
				break;	
				case "收到其他与筹资活动有关的现金":
					let p20 = period.find(item => item.name === "收到其他与筹资活动有关的现金");
					let y20 = year.find(item => item.name === "收到其他与筹资活动有关的现金");
					if(y20){items.values.本年累计金额 = (Number(y20.currentDebitAmount) + (-Number(y20.currentCreditAmount))).toFixed(2)}
					if(p20){items.values.本期金额 = (Number(p20.currentDebitAmount) + (-Number(p20.currentCreditAmount))).toFixed(2)}
					if(p20)netAmount3.本期金额 = (Number(items.values.本期金额) + Number(netAmount3.本期金额)).toFixed(2);
					if(y20){netAmount3.本年累计金额 = (Number(items.values.本年累计金额) + Number(netAmount3.本年累计金额)).toFixed(2)};
				break;	
				case "偿还债务支付的现金":
					let p21 = period.find(item => item.name === "偿还债务支付的现金");
					let y21 = year.find(item => item.name === "偿还债务支付的现金");
					if(y21)items.values.本年累计金额 = -(Number(y21.currentDebitAmount) + (-Number(y21.currentCreditAmount))).toFixed(2)
					if(p21)items.values.本期金额 = -(Number(p21.currentDebitAmount) + (-Number(p21.currentCreditAmount))).toFixed(2)
					if(p21)netAmount4.本期金额 = (Number(netAmount4.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y21)netAmount4.本年累计金额 = (Number(netAmount4.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "分配股利、利润或偿付利息支付的现金":
					let p22 = period.find(item => item.name === "分配股利、利润或偿付利息支付的现金");
					let y22 = year.find(item => item.name === "分配股利、利润或偿付利息支付的现金");
					if(y22)items.values.本年累计金额 = -(Number(y22.currentDebitAmount) + (-Number(y22.currentCreditAmount))).toFixed(2)
					if(p22)items.values.本期金额 = -(Number(p22.currentDebitAmount) + (-Number(p22.currentCreditAmount))).toFixed(2)
					if(p22)netAmount4.本期金额 = (Number(netAmount4.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y22)netAmount4.本年累计金额 = (Number(netAmount4.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;
				case "支付其他与筹资活动有关的现金":
					let p23 = period.find(item => item.name === "支付其他与筹资活动有关的现金");
					let y23 = year.find(item => item.name === "支付其他与筹资活动有关的现金");
					if(y23)items.values.本年累计金额 = -(Number(y23.currentDebitAmount) + (-Number(y23.currentCreditAmount))).toFixed(2)
					if(p23)items.values.本期金额 = -(Number(p23.currentDebitAmount) + (-Number(p23.currentCreditAmount))).toFixed(2)
					if(p23)netAmount4.本期金额 = (Number(netAmount4.本期金额) + Number(items.values.本期金额)).toFixed(2);
					if(y23)netAmount4.本年累计金额 = (Number(netAmount4.本年累计金额) + Number(items.values.本年累计金额)).toFixed(2);
				break;

				case "四、汇率变动对现金及现金等价物的影响":
					let p24 = period.find(item => item.name === "汇率变动对现金及现金等价物的影响");
					let y24 = year.find(item => item.name === "汇率变动对现金及现金等价物的影响");
					if(y24){items.values.本年累计金额 = (Number(y24.currentDebitAmount) + (-Number(y24.currentCreditAmount))).toFixed(2)}
					if(p24){items.values.本期金额 = (Number(p24.currentDebitAmount) + (-Number(p24.currentCreditAmount))).toFixed(2)}
				break;	
			}
		})
		let o = original.find(item => item.title === "经营活动现金流入小计");
		o.values.本期金额 = oneNetAmount.本期金额;
		o.values.本年累计金额 = oneNetAmount.本年累计金额;
		let t = original.find(item => item.title === "经营活动现金流出小计");
		t.values.本期金额 = twoNetAmount.本期金额;
		t.values.本年累计金额 = twoNetAmount.本年累计金额;
		let t2 = original.find(item => item.title === "经营活动产生的现金流量净额");
		t2.values.本期金额 = (Number(oneNetAmount.本期金额) - Number(twoNetAmount.本期金额)).toFixed(2);
		t2.values.本年累计金额 = (Number(oneNetAmount.本年累计金额) - Number(twoNetAmount.本年累计金额)).toFixed(2);

		let t3 = original.find(item => item.title === "投资活动现金流入小计");
		t3.values.本期金额 = netAmount1.本期金额;
		t3.values.本年累计金额 = netAmount1.本年累计金额;

		let t4 = original.find(item => item.title === "投资活动现金流出小计");
		t4.values.本期金额 = netAmount2.本期金额;
		t4.values.本年累计金额 = netAmount2.本年累计金额;

		let t5 = original.find(item => item.title === "投资活动产生的现金流量净额");
		t5.values.本期金额 = (Number(netAmount1.本期金额) - Number(netAmount2.本期金额)).toFixed(2);
		t5.values.本年累计金额 = (Number(netAmount1.本年累计金额) - Number(netAmount2.本年累计金额)).toFixed(2);

		let t6 = original.find(item => item.title === "筹资活动现金流入小计");
		t6.values.本期金额 = netAmount3.本期金额;
		t6.values.本年累计金额 = netAmount3.本年累计金额;

		let t7 = original.find(item => item.title === "筹资活动现金流出小计");
		t7.values.本期金额 = netAmount4.本期金额;
		t7.values.本年累计金额 = netAmount4.本年累计金额;

		let t8 = original.find(item => item.title === "筹资活动产生的现金流量净额");
		t8.values.本期金额 = (Number(netAmount3.本期金额) - Number(netAmount4.本期金额)).toFixed(2);
		t8.values.本年累计金额 = (Number(netAmount3.本年累计金额) - Number(netAmount4.本年累计金额)).toFixed(2);

		let t9 = original.find(item => item.title === "四、汇率变动对现金及现金等价物的影响");

		let t10 = original.find(item => item.title === "五、现金及现金等价物净增加额");
		t10.values.本期金额 = (Number(t2.values.本期金额) + Number(t5.values.本期金额) + Number(t8.values.本期金额) + Number(t9.values.本期金额)).toFixed(2);
		t10.values.本年累计金额 = (Number(t2.values.本年累计金额) + Number(t5.values.本年累计金额) + Number(t8.values.本年累计金额) + Number(t9.values.本年累计金额)).toFixed(2);

		let t11 = original.find(item => item.title === "加：期初现金及现金等价物余额");
		let t12 = original.find(item => item.title === "六、期末现金余额");
		t12.values.本期金额 = (Number(t10.values.本期金额) + Number(t11.values.本期金额)).toFixed(2);
		t12.values.本年累计金额 = (Number(t10.values.本年累计金额) + Number(t11.values.本年累计金额)).toFixed(2);
		return original;
	}
}

const items = ref(toArrayTree(report.value.items));
const startIndex = ref(0);
const loadData = () => {
	loading.value = true;
	//report.value.templateKey  各种报表的标识
	ReportApi.view(report.value.templateKey, {
		voucherDate: voucherDate.value,
		dimension: dimension.value
	}).then(({data}) => {
		//如果是资产负债表，做平衡检测↓jxd负债表平衡检测
		if (report.value.templateKey === "zcfz") checkBalance(data);
		// ↑jxd负债表平衡检测

		//如果是现金流，则查询现金流调整
		if (report.value.templateKey === "xjll" && dimension.value === 'QUARTER'){
			afterRep.value = false;
			yCashFlow();
			mCashFlow('QUARTER');
		}else{
			// if(afterReportShow.value){afterReportShow()}
			afterRep.value = false;
			yCashFlow();
			mCashFlow();
		}


		//现金流辅助核算法尝试
		let xjlfz = [];
		if(xjllFZHS.value == 1  && dimension.value === 'QUARTER' && report.value.templateKey === "xjll"){
			let dateString = manba(voucherDate.value).format('YYYY-MM');
			let parts = dateString.split('-');  
			let year = parseInt(parts[0], 10);  
			let month = parseInt(parts[1], 10) - 1; // 注意月份是从0开始的，所以需要减1
			let date = new Date(year, month, 1); // 设置为该月的第一天  )
			// 增加月份  
			date.setMonth(date.getMonth() + 2);  
			let newYear = date.getFullYear();  
    		let newMonth = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份需要加1并补零
			let endDate = newYear + '-' + newMonth;
			//选择的辅助核算法
			
			//查出当年
			let years = manba(voucherDate.value).format('YYYY')
			let firstMonth = years + '-01';  
			let lastMonth = years + '-12';  
			Promise.all([
				accountbook.loadAuxiliaryBalance({
					auxiliaryId: 7,
					showSubject: false,
					start: manba(voucherDate.value).format('YYYY-MM'),
					end: endDate,
				}),
				accountbook.loadAuxiliaryBalance({
					auxiliaryId: 7,
					showSubject: false,
					start: firstMonth,
					end: endDate,
				})
			]).then((reslut) => {
				// console.log(reslut[0].data)//季度
				// console.log(reslut[1].data)//年度
				// console.log(data,User.accountSets.accountStandard);//现金流普通公式法的数据
				xjlfz = xjlCal(reslut[0].data,reslut[1].data,data,User.accountSets.accountStandard)
				reportItems.value = xjlfz;
				let tree = toArrayTree(xjlfz);
				// console.log(tree)
				if (tree.filter(f => f.isClassified).length > 0) {
					let rows = [];
					tree.forEach(root => {
						buildRow(root.children, rows, root.title, 0)
						startIndex.value = 0;
					})
					dataList.value = rows;
				} else {
					let rows = [];
					buildRow(tree, rows, '项目', 0)
					dataList.value = rows;
				}
			})
		}else if(xjllFZHS.value == 1 && report.value.templateKey === "xjll"){
			let year = manba(voucherDate.value).format('YYYY')
			let firstMonth = year + '-01';  
			let lastMonth = year + '-12';  
			Promise.all([
				//查出当月
				accountbook.loadAuxiliaryBalance({
					auxiliaryId: 7,
					showSubject: false,
					start: manba(voucherDate.value).format('YYYY-MM'),
					end: manba(voucherDate.value).format('YYYY-MM'),
				}),
				//查出当年
				accountbook.loadAuxiliaryBalance({
					auxiliaryId: 7,
					showSubject: false,
					start: firstMonth,
					end: manba(voucherDate.value).format('YYYY-MM'),
				})
			]).then((reslut) => {
				xjlfz = xjlCal(reslut[0].data,reslut[1].data,data,User.accountSets.accountStandard)
				reportItems.value = xjlfz;
				let tree = toArrayTree(xjlfz);
				// console.log(tree)
				if (tree.filter(f => f.isClassified).length > 0) {
					let rows = [];
					tree.forEach(root => {
						buildRow(root.children, rows, root.title, 0)
						startIndex.value = 0;
					})
					dataList.value = rows;
				} else {
					let rows = [];
					buildRow(tree, rows, '项目', 0)
					startIndex.value = 0;
					dataList.value = rows;
				}
			})
		}else{
			reportItems.value = data;
			let tree = toArrayTree(data);
			// console.log(tree)
			if (tree.filter(f => f.isClassified).length > 0) {
				let rows = [];
				tree.forEach(root => {
					buildRow(root.children, rows, root.title, 0)
					startIndex.value = 0;
				})
				dataList.value = rows;
			} else {
				let rows = [];
				buildRow(tree, rows, '项目', 0)
				startIndex.value = 0;
				dataList.value = rows;
			}
		}
	}).finally(() => loading.value = false);
}
loadData()

//资产负债表平衡检测jxd data负债表数据
const checkBalance = (data) => {
	// jxd 负债表平衡检测
	let totalAssets;
	let liabilitiesAndOwner;
	for(let i =0; i<data.length;i++){
		if(data[i].title == "资产合计"){
			totalAssets = data[i].values;
			//适应工会资产负债表
		}else if(data[i].title == "负债和所有者权益（或股东权益）" || data[i].title == "负债与净资产总计" || data[i].title == "负债及业主权益总计"){
			liabilitiesAndOwner = data[i].values;
		}
	}
	//对比判断
	if(VXETable.formats.store.toMoney({cellValue:totalAssets.年初余额}) === VXETable.formats.store.toMoney({cellValue:liabilitiesAndOwner.年初余额}) && VXETable.formats.store.toMoney({cellValue:totalAssets.期末余额}) === VXETable.formats.store.toMoney({cellValue:liabilitiesAndOwner.期末余额})){
		//一致
		msgBalance.value = "";
	}else{
		//不一致
		msgBalance.value = "不平衡";
	}
}

const buildRow = (items, rows, colTitle, lv) => {
	for (let i = 0; i < items.length; i++) {
		let item = items[i];
		if (!rows[startIndex.value]) {
			rows[startIndex.value] = {}
		}
		rows[startIndex.value][colTitle] = item.title;
		rows[startIndex.value][colTitle + "isBolder"] = item.isBolder;
		rows[startIndex.value][colTitle + "rowNum"] = item.rowNum;
		rows[startIndex.value][colTitle + "lv"] = lv;
		rows[startIndex.value][colTitle + "editFormulas"] = item.editFormulas;
		rows[startIndex.value][colTitle + "id"] = item.id;

		Object.keys(item.values).forEach(key => {
			rows[startIndex.value][colTitle + key] = VXETable.formats.store.toMoney({cellValue: item.values[key]});
		})
		startIndex.value++;
		if (item.children && item.children.length > 0) {
			buildRow(item.children, rows, colTitle, lv + 1);
		}
	}
}

watch(voucherDate, () => {
	loadData();
})

const editFormula = (itemId) => {
	let layerId = layer.open({
		title: "公式编辑",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['1000px', 'auto'],
		content: h(TemplateItemFormulaModal, {
			templateItem: report.value.items.find(val => val.id === itemId),
			templateItems: report.value.items,
			template: report.value,
			onClose: () => {
				layer.close(layerId);
			},
			onSuccess: () => {
				EventBus.emit("report.reload")
				layer.close(layerId);
			}
		})
	});
}

const huiTitle = () => {
	let title = "会"
	title += dictMapping(currentAccountSets.accountStandard, 'accountingStandardsPrint')
	title += dictMapping(report.value.templateKey, 'reportPrint')
	return title;
}

const pdfWidth = {
	项目: 117,
	资产: 43,
	负债和净资产: 43,
	负债和所有者权益: 43,
	负债及业主权益: 43,
	行次: 15,
	期末余额: 35,
	年初余额: 35,
	本年累计金额: 60,
	本期金额: 60,
	本月数:60,
	本年数:60,
	本年金额:60,
}

const printData = () => {
	const offsetY = 10; // 例如下移10毫米，您可以根据实际需求调整这个值     jxd设置上边距
	let size = '';
	if(User.accountSets.accountStandard == 'BUSINESS_NEW_2019' || User.accountSets.accountStandard == 'BUSINESS'){
		//2019 和企业全部加长
		size = 'big'
	}
	print.print({putOnlyUsedFonts: true},size).then((doc) => {
		doc.setFontSize(16);
		doc.text(report.value.name, 105, 10+offsetY, {align: 'center'})
		doc.setFontSize(9);
		doc.text(huiTitle(), 200, 15+offsetY, {align: 'right', lineHeightFactor: 0.5})
		doc.text("编制单位：" + currentAccountSets.companyName, 10, 20+offsetY)
		doc.text(showDate.value, 105, 20+offsetY, null, null, 'center')
		doc.text("单位：元", 200, 20+offsetY, null, null, 'right')

		let headers = xTable.value.getColumns();
		let {fullData} = xTable.value.getTableData();
		doc.table(10, 22+offsetY, fullData.map(item => {
			let row = {};
			headers.forEach(h => {
				let val = item[h.property] || " ";
				if (['资产', '负债和所有者权益', '项目'].includes(h.property)) {
					val = repeat(" ", (item[h.property + "lv"] || 0) * 2) + val;
				}
				row[h.property] = val
			})
			return row;
		}), headers.map(val => {
			console.log(val.title)
			return {
				id: val.property,
				name: val.property,
				prompt: val.title,
				width: pdfWidth[val.title.trim()],
				align: val.align
			}
		}), {
			padding: 2, css: {
				"font-size": 0.5
			}
		})
		doc.print(report.value.name);
	})
}

const xlsWidth = {
	项目: 46,
	资产: 25,
	负债和所有者权益: 25,
	行次: 7,
	期末余额: 22,
	年初余额: 22,
	本年累计金额: 22,
	本期金额: 22,
}

const reportCols = report.value.reportCols.map(val => val.title)

const exportData = () => {
	let headers = xTable.value.getColumns();
	let {fullData} = xTable.value.getTableData();

	const wb = new ExcelJS.Workbook();
	const ws = wb.addWorksheet(props.report.title);
	//标题
	let headerCell = ws.getCell("A1");
	ws.mergeCells(1, 1, 1, headers.length);
	headerCell.font = {
		bold: true,
		size: 16,
	};
	headerCell.alignment = {vertical: 'middle', horizontal: 'center'};
	headerCell.value = report.value.name;
	//二级标题
	let subHeaderCell = ws.getCell("A2");
	ws.mergeCells(2, 1, 2, headers.length);
	subHeaderCell.alignment = {vertical: 'center', horizontal: 'right'};
	subHeaderCell.value = huiTitle();
	//企业
	//二级标题
	let companyNameCell = ws.getCell("A3");
	companyNameCell.value = "编制单位：" + currentAccountSets.companyName;
	//日期
	let dateCell = ws.getCell("B3");
	ws.mergeCells(3, 2, 3, headers.length - 1);
	dateCell.value = showDate.value;
	//币别
	let currencyCell = ws.getCell(3, headers.length);
	currencyCell.value = "单位：元";
	currencyCell.alignment = {vertical: 'center', horizontal: 'right'};

	headers.forEach((item, index) => {
		let cell = ws.getCell(4, index + 1);
		cell.font = {
			bold: true,
			size: 13,
		};
		cell.value = item.title;
		cell.alignment = {vertical: 'center', horizontal: item.align};

		ws.getColumn(index + 1).width = xlsWidth[item.title];
		thinBorder(cell);
	})

	const rows = fullData.map(item => {
		let row = {};
		headers.forEach(h => {
			let val = item[h.property] || " ";
			if (['资产', '负债和所有者权益', '项目'].includes(h.property)) {
				val = repeat(" ", (item[h.property + "lv"] || 0) * 2) + val;
			}
			row[h.property] = val
		})
		return row;
	});

	rows.forEach((row, rIndex) => {
		headers.forEach((h, colIndex) => {
			let cell = ws.getCell(5 + rIndex, colIndex + 1);
			cell.font = {
				size: 9,
			};
			cell.alignment = {vertical: 'center', horizontal: h.align};
			if (reportCols.includes(h.title) && row[h.property] && row[h.property].trim()) {
				cell.value = row[h.property] ? Number(row[h.property].replaceAll(",", "")) : '';
				cell.numFmt = "#,##0.00_);[Red](#,##0.00)"
			} else {
				cell.value = row[h.property];
			}
			thinBorder(cell);
		})
	})

	wb.xlsx.writeBuffer().then(buffer => {
		downloadBlob(`${manba().format('YYYYMMDDHHmm')}${report.value.name}.xlsx`, new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}))
	})
}

const thinBorder = (cell) => {
	cell.border = {
		top: {style: 'thin'},
		left: {style: 'thin'},
		bottom: {style: 'thin'},
		right: {style: 'thin'}
	};
}
</script>
<style lang="less" scoped>
.col-title-edit {
	display: none;
}

.col-title:hover {
	.col-title-edit {
		display: inline-block;
	}
}
</style>
